import { render } from "./CourseLessons.vue?vue&type=template&id=942fb462&scoped=true&ts=true"
import script from "./CourseLessons.vue?vue&type=script&lang=ts"
export * from "./CourseLessons.vue?vue&type=script&lang=ts"

import "./CourseLessons.vue?vue&type=style&index=0&id=942fb462&lang=scss&scoped=true"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-942fb462"]])

export default __exports__